import english from '../src/lang/en.json';
import { IntlProvider } from 'react-intl';
import polish from '../src/lang/pl.json';
import portuguese from '../src/lang/pt.json';
import spanish from '../src/lang/es.json';
import spanishLatAm from '../src/lang/es_419.json';

export default function HallowIntlProvider({ children }) {
    let messages;
    switch (process.env.REACT_APP_LOCALE) {
        case 'es': messages = spanish; break;
        case 'es-419': messages = spanishLatAm; break;
        case 'pt': messages = portuguese; break;
        case 'pl': messages = polish; break;
        default: messages = english;
    }
    return <IntlProvider locale={process.env.REACT_APP_LOCALE} messages={messages} defaultLocale={'en'}>
        {children}
    </IntlProvider>;
}